module.exports = __webpack_public_path__ + "assets/img/52@3x.38d30f59.png";